<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table id="ni-price-info-table">
      <thead>
        <tr>
          <th>Line No.</th>
          <th
            v-for="columnData in priceInfoFields.columns"
            :key="columnData.id"
            :class="columnData.className"
            :title="columnData.title"
          >
            <label>{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-app-price-info-tbody">
        <tr
          v-for="(row, index) in rows"
          :key="row.id"
          :class="[
            row.itemStatus === 'Rework – Additional Data Required'
              ? 'rework-item'
              : ''
          ]"
          @click="onRowClick($event)"
          @change="!isLoading ? changeOnRow($event, index, row) : ''"
        >
          <ValidationObserver>
            <td class="line-number">{{ row.lineNumber }}</td>
            <td class="line-errors">{{ row.lineErrors }}</td>
            <td class="supp-item-nbr">
              <b-input
                class="suppItemNbr"
                v-model="row.suppItemNbr"
                disabled
              ></b-input>
            </td>
            <td>
              <b-input
                class="englishPrdctNoun"
                disabled
                :value="row.englishPrdctNoun"
                :class="
                  isApiErrorField(
                    row.psfsEuNewItemGiErrTbs,
                    'englishPrdctNoun',
                    row.englishPrdctNoun
                  )
                "
              ></b-input>
            </td>
            <td>
              <b-input
                class="itemStatus"
                v-model="row.itemStatus"
                disabled
                :title="row.itemStatus"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.unitPrice"
                    :value="
                      row.unitPrice === undefined
                        ? (row.unitPrice = ' ')
                        : row.unitPrice
                    "
                    class="unitPrice"
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'unitPrice',
                        row.unitPrice
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="Main">Main</option
                    ><option value="Alternate">Alternate</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ukRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ukRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ukRecListPrcCur"
                    v-model="row.ukRecListPrcCur"
                    :value="
                      row.ukRecListPrcCur === undefined
                        ? (row.ukRecListPrcCur = ' ')
                        : row.ukRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ukRecListPrcCur',
                        row.ukRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ukRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ukRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ukRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ukRecListPrc = $event.target.value"
                    :value="
                      row.ukRecListPrc !== undefined
                        ? addTwoZerosMode(row.ukRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ukRecListPrc',
                        row.ukRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="ukDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.ukDscntFrmList = $event.target.value"
                :value="row.ukDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'ukDscntFrmList',
                    row.ukDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ukFrNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ukFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ukFrNetPrcCurr"
                    v-model="row.ukFrNetPrcCurr"
                    :value="
                      row.ukFrNetPrcCurr === undefined
                        ? (row.ukFrNetPrcCurr = ' ')
                        : row.ukFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ukFrNetPrcCurr',
                        row.ukFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option>
                    <option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ukFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ukFrNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ukFrNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ukFrNetPrc = $event.target.value"
                    :value="
                      row.ukFrNetPrc !== undefined && row.ukFrNetPrc !== 0
                        ? addTwoZerosMode(row.ukFrNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ukFrNetPrc',
                        row.ukFrNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'ukFrNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:frRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="frRecListPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="frRecListPrcCurr"
                    @change.native="row.frRecListPrcCurr = $event.target.value"
                    v-model="row.frRecListPrcCurr"
                    :value="
                      row.frRecListPrcCurr === undefined
                        ? (row.frRecListPrcCurr = ' ')
                        : row.frRecListPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'frRecListPrcCurr',
                        row.frRecListPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:frRecListPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="frRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="frRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.frRecListPrc = $event.target.value"
                    :value="
                      row.frRecListPrc !== undefined
                        ? addTwoZerosMode(row.frRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'frRecListPrc',
                        row.frRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="frDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.frDscntFrmList = $event.target.value"
                :value="row.frDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'frDscntFrmList',
                    row.frDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:frNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="frNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="frNetPrcCurr"
                    v-model="row.frNetPrcCurr"
                    :value="
                      row.frNetPrcCurr === undefined
                        ? (row.frNetPrcCurr = ' ')
                        : row.frNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'frNetPrcCurr',
                        row.frNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:frNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="frNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="frNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.frNetPrc = $event.target.value"
                    :value="
                      row.frNetPrc !== undefined && row.frNetPrc !== 0
                        ? addTwoZerosMode(row.frNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'frNetPrc',
                        row.frNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'frNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:deRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="deRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="deRecListPrcCur"
                    v-model="row.deRecListPrcCur"
                    :value="
                      row.deRecListPrcCur === undefined
                        ? (row.deRecListPrcCur = ' ')
                        : row.deRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'deRecListPrcCur',
                        row.deRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:deRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="deRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="deRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.deRecListPrc = $event.target.value"
                    :value="
                      row.deRecListPrc !== undefined
                        ? addTwoZerosMode(row.deRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'deRecListPrc',
                        row.deRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="deDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.deDscntFrmList = $event.target.value"
                :value="row.deDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'deDscntFrmList',
                    row.deDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:deNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="deFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="deFrNetPrcCurr"
                    v-model="row.deFrNetPrcCurr"
                    :value="
                      row.deFrNetPrcCurr === undefined
                        ? (row.deFrNetPrcCurr = ' ')
                        : row.deFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'deFrNetPrcCurr',
                        row.deFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:deFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="deNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="deNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.deNetPrc = $event.target.value"
                    :value="
                      row.deNetPrc !== undefined && row.deNetPrc !== 0
                        ? addTwoZerosMode(row.deNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'deNetPrc',
                        row.deNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'deNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:seRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="seRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="seRecListPrcCur"
                    v-model="row.seRecListPrcCur"
                    :value="
                      row.seRecListPrcCur === undefined
                        ? (row.seRecListPrcCur = ' ')
                        : row.seRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'seRecListPrcCur',
                        row.seRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:seRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="seRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="seRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.seRecListPrc = $event.target.value"
                    :value="
                      row.seRecListPrc !== undefined
                        ? addTwoZerosMode(row.seRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'seRecListPrc',
                        row.seRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="seDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.seDscntFrmList = $event.target.value"
                :value="row.seDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'seDscntFrmList',
                    row.seDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:seNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="seFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="seFrNetPrcCurr"
                    v-model="row.seFrNetPrcCurr"
                    :value="
                      row.seFrNetPrcCurr === undefined
                        ? (row.seFrNetPrcCurr = ' ')
                        : row.seFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'seFrNetPrcCurr',
                        row.seFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:seFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="seNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="seNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.seNetPrc = $event.target.value"
                    :value="
                      row.seNetPrc !== undefined && row.seNetPrc !== 0
                        ? addTwoZerosMode(row.seNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'seNetPrc',
                        row.seNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'seNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:esRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="esRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="esRecListPrcCur"
                    v-model="row.esRecListPrcCur"
                    :value="
                      row.esRecListPrcCur === undefined
                        ? (row.esRecListPrcCur = ' ')
                        : row.esRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'esRecListPrcCur',
                        row.esRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:esRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="esRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="esRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.esRecListPrc = $event.target.value"
                    :value="
                      row.esRecListPrc !== undefined
                        ? addTwoZerosMode(row.esRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'esRecListPrc',
                        row.esRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="esDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.esDscntFrmList = $event.target.value"
                :value="row.esDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'esDscntFrmList',
                    row.esDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:esNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="esFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="esFrNetPrcCurr"
                    v-model="row.esFrNetPrcCurr"
                    :value="
                      row.esFrNetPrcCurr === undefined
                        ? (row.esFrNetPrcCurr = ' ')
                        : row.esFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'esFrNetPrcCurr',
                        row.esFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:esFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="esNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="esNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.esNetPrc = $event.target.value"
                    :value="
                      row.esNetPrc !== undefined && row.esNetPrc !== 0
                        ? addTwoZerosMode(row.esNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'esNetPrc',
                        row.esNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'esNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:atRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="atRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="atRecListPrcCur"
                    v-model="row.atRecListPrcCur"
                    :value="
                      row.atRecListPrcCur === undefined
                        ? (row.atRecListPrcCur = ' ')
                        : row.atRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'atRecListPrcCur',
                        row.atRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:atRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="atRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="atRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.atRecListPrc = $event.target.value"
                    :value="
                      row.atRecListPrc !== undefined
                        ? addTwoZerosMode(row.atRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'atRecListPrc',
                        row.atRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="atDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.atDscntFrmList = $event.target.value"
                :value="row.atDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'atDscntFrmList',
                    row.atDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:atNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="atFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="atFrNetPrcCurr"
                    v-model="row.atFrNetPrcCurr"
                    :value="
                      row.atFrNetPrcCurr === undefined
                        ? (row.atFrNetPrcCurr = ' ')
                        : row.atFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'atFrNetPrcCurr',
                        row.atFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:atFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="atNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="atNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.atNetPrc = $event.target.value"
                    :value="
                      row.atNetPrc !== undefined && row.atNetPrc !== 0
                        ? addTwoZerosMode(row.atNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'atNetPrc',
                        row.atNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'atNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:fiRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="fiRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="fiRecListPrcCur"
                    v-model="row.fiRecListPrcCur"
                    :value="
                      row.fiRecListPrcCur === undefined
                        ? (row.fiRecListPrcCur = ' ')
                        : row.fiRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'fiRecListPrcCur',
                        row.fiRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:fiRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="fiRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="fiRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.fiRecListPrc = $event.target.value"
                    :value="
                      row.fiRecListPrc !== undefined
                        ? addTwoZerosMode(row.fiRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'fiRecListPrc',
                        row.fiRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="fiDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.fiDscntFrmList = $event.target.value"
                :value="row.fiDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'fiDscntFrmList',
                    row.fiDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:fiNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="fiFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="fiFrNetPrcCurr"
                    v-model="row.fiFrNetPrcCurr"
                    :value="
                      row.fiFrNetPrcCurr === undefined
                        ? (row.fiFrNetPrcCurr = ' ')
                        : row.fiFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'fiFrNetPrcCurr',
                        row.fiFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:fiFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="fiNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="fiNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.fiNetPrc = $event.target.value"
                    :value="
                      row.fiNetPrc !== undefined && row.fiNetPrc !== 0
                        ? addTwoZerosMode(row.fiNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'fiNetPrc',
                        row.fiNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'fiNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:noRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="noRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="noRecListPrcCur"
                    v-model="row.noRecListPrcCur"
                    :value="
                      row.noRecListPrcCur === undefined
                        ? (row.noRecListPrcCur = ' ')
                        : row.noRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'noRecListPrcCur',
                        row.noRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:noRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="noRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="noRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.noRecListPrc = $event.target.value"
                    :value="
                      row.noRecListPrc !== undefined
                        ? addTwoZerosMode(row.noRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'noRecListPrc',
                        row.noRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="noDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.noDscntFrmList = $event.target.value"
                :value="row.noDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'noDscntFrmList',
                    row.noDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:noNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="noFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="noFrNetPrcCurr"
                    v-model="row.noFrNetPrcCurr"
                    :value="
                      row.noFrNetPrcCurr === undefined
                        ? (row.noFrNetPrcCurr = ' ')
                        : row.noFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'noFrNetPrcCurr',
                        row.noFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:noFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="noNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="noNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.noNetPrc = $event.target.value"
                    :value="
                      row.noNetPrc !== undefined && row.noNetPrc !== 0
                        ? addTwoZerosMode(row.noNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'noNetPrc',
                        row.noNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'noNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:dkRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="dkRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="dkRecListPrcCur"
                    v-model="row.dkRecListPrcCur"
                    :value="
                      row.dkRecListPrcCur === undefined
                        ? (row.dkRecListPrcCur = ' ')
                        : row.dkRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'dkRecListPrcCur',
                        row.dkRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:dkRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="dkRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="dkRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.dkRecListPrc = $event.target.value"
                    :value="
                      row.dkRecListPrc !== undefined
                        ? addTwoZerosMode(row.dkRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'dkRecListPrc',
                        row.dkRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="dkDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.dkDscntFrmList = $event.target.value"
                :value="row.dkDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'dkDscntFrmList',
                    row.dkDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:dkNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="dkFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="dkFrNetPrcCurr"
                    v-model="row.dkFrNetPrcCurr"
                    :value="
                      row.dkFrNetPrcCurr === undefined
                        ? (row.dkFrNetPrcCurr = ' ')
                        : row.dkFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'dkFrNetPrcCurr',
                        row.dkFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:dkFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="dkNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="dkNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.dkNetPrc = $event.target.value"
                    :value="
                      row.dkNetPrc !== undefined && row.dkNetPrc !== 0
                        ? addTwoZerosMode(row.dkNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'dkNetPrc',
                        row.dkNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'dkNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ptRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ptRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ptRecListPrcCur"
                    v-model="row.ptRecListPrcCur"
                    :value="
                      row.ptRecListPrcCur === undefined
                        ? (row.ptRecListPrcCur = ' ')
                        : row.ptRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ptRecListPrcCur',
                        row.ptRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ptRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ptRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ptRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ptRecListPrc = $event.target.value"
                    :value="
                      row.ptRecListPrc !== undefined
                        ? addTwoZerosMode(row.ptRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ptRecListPrc',
                        row.ptRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="ptDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.ptDscntFrmList = $event.target.value"
                :value="row.ptDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'ptDscntFrmList',
                    row.ptDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ptNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ptFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ptFrNetPrcCurr"
                    v-model="row.ptFrNetPrcCurr"
                    :value="
                      row.ptFrNetPrcCurr === undefined
                        ? (row.ptFrNetPrcCurr = ' ')
                        : row.ptFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ptFrNetPrcCurr',
                        row.ptFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ptFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ptNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ptNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ptNetPrc = $event.target.value"
                    :value="
                      row.ptNetPrc !== undefined && row.ptNetPrc !== 0
                        ? addTwoZerosMode(row.ptNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ptNetPrc',
                        row.ptNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'ptNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:chRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="chRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="chRecListPrcCur"
                    v-model="row.chRecListPrcCur"
                    :value="
                      row.chRecListPrcCur === undefined
                        ? (row.chRecListPrcCur = ' ')
                        : row.chRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'chRecListPrcCur',
                        row.chRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:chRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="chRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="chRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.chRecListPrc = $event.target.value"
                    :value="
                      row.chRecListPrc !== undefined
                        ? addTwoZerosMode(row.chRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'chRecListPrc',
                        row.chRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="chDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.chDscntFrmList = $event.target.value"
                :value="row.chDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'chDscntFrmList',
                    row.chDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:chNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="chFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="chFrNetPrcCurr"
                    v-model="row.chFrNetPrcCurr"
                    :value="
                      row.chFrNetPrcCurr === undefined
                        ? (row.chFrNetPrcCurr = ' ')
                        : row.chFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'chFrNetPrcCurr',
                        row.chFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:chFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="chNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="chNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.chNetPrc = $event.target.value"
                    :value="
                      row.chNetPrc !== undefined && row.chNetPrc !== 0
                        ? addTwoZerosMode(row.chNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'chNetPrc',
                        row.chNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'chNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:nlRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="nlRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="nlRecListPrcCur"
                    v-model="row.nlRecListPrcCur"
                    :value="
                      row.nlRecListPrcCur === undefined
                        ? (row.nlRecListPrcCur = ' ')
                        : row.nlRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'nlRecListPrcCur',
                        row.nlRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:nlRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="nlRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="nlRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.nlRecListPrc = $event.target.value"
                    :value="
                      row.nlRecListPrc !== undefined
                        ? addTwoZerosMode(row.nlRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'nlRecListPrc',
                        row.nlRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="nlDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.nlDscntFrmList = $event.target.value"
                :value="row.nlDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'nlDscntFrmList',
                    row.nlDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:nlNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="nlFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="nlFrNetPrcCurr"
                    v-model="row.nlFrNetPrcCurr"
                    :value="
                      row.nlFrNetPrcCurr === undefined
                        ? (row.nlFrNetPrcCurr = ' ')
                        : row.nlFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'nlFrNetPrcCurr',
                        row.nlFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:nlFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="nlNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="nlNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.nlNetPrc = $event.target.value"
                    :value="
                      row.nlNetPrc !== undefined && row.nlNetPrc !== 0
                        ? addTwoZerosMode(row.nlNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'nlNetPrc',
                        row.nlNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'nlNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:beRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="beRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="beRecListPrcCur"
                    v-model="row.beRecListPrcCur"
                    :value="
                      row.beRecListPrcCur === undefined
                        ? (row.beRecListPrcCur = ' ')
                        : row.beRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'beRecListPrcCur',
                        row.beRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:beRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="beRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="beRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.beRecListPrc = $event.target.value"
                    :value="
                      row.beRecListPrc !== undefined
                        ? addTwoZerosMode(row.beRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'beRecListPrc',
                        row.beRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="beDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.beDscntFrmList = $event.target.value"
                :value="row.beDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'beDscntFrmList',
                    row.beDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:beNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="beFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="beFrNetPrcCurr"
                    v-model="row.beFrNetPrcCurr"
                    :value="
                      row.beFrNetPrcCurr === undefined
                        ? (row.beFrNetPrcCurr = ' ')
                        : row.beFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'beFrNetPrcCurr',
                        row.beFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option>
                    <option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:beFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="beNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="beNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.beNetPrc = $event.target.value"
                    :value="
                      row.beNetPrc !== undefined && row.beNetPrc !== 0
                        ? addTwoZerosMode(row.beNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'beNetPrc',
                        row.beNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'beNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ieRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ieRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ieRecListPrcCur"
                    v-model="row.ieRecListPrcCur"
                    :value="
                      row.ieRecListPrcCur === undefined
                        ? (row.ieRecListPrcCur = ' ')
                        : row.ieRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ieRecListPrcCur',
                        row.ieRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ieRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ieRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ieRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ieRecListPrc = $event.target.value"
                    :value="
                      row.ieRecListPrc !== undefined
                        ? addTwoZerosMode(row.ieRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ieRecListPrc',
                        row.ieRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="ieDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.ieDscntFrmList = $event.target.value"
                :value="row.ieDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'ieDscntFrmList',
                    row.ieDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ieNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ieFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="ieFrNetPrcCurr"
                    v-model="row.ieFrNetPrcCurr"
                    :value="
                      row.ieFrNetPrcCurr === undefined
                        ? (row.ieFrNetPrcCurr = ' ')
                        : row.ieFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ieFrNetPrcCurr',
                        row.ieFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option></b-select
                  >
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:ieFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="ieNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="ieNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.ieNetPrc = $event.target.value"
                    :value="
                      row.ieNetPrc !== undefined && row.ieNetPrc !== 0
                        ? addTwoZerosMode(row.ieNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'ieNetPrc',
                        row.ieNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'ieNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:itRecListPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="itRecListPrcCur"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="itRecListPrcCur"
                    v-model="row.itRecListPrcCur"
                    :value="
                      row.itRecListPrcCur === undefined
                        ? (row.itRecListPrcCur = ' ')
                        : row.itRecListPrcCur
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'itRecListPrcCur',
                        row.itRecListPrcCur
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:itRecListPrcCur"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="itRecListPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="itRecListPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.itRecListPrc = $event.target.value"
                    :value="
                      row.itRecListPrc !== undefined
                        ? addTwoZerosMode(row.itRecListPrc)
                        : ''
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'itRecListPrc',
                        row.itRecListPrc
                      )
                    "
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                class="itDscntFrmList"
                oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 5) this.value = this.value.split('.')[0].slice(0, 5) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                @change.native="row.itDscntFrmList = $event.target.value"
                :value="row.itDscntFrmList"
                :class="[
                  isApiErrorField(
                    row.psfsEuNewItemPiErrTbs,
                    'itDscntFrmList',
                    row.itDscntFrmList
                  )
                ]"
              ></b-input>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:itNetPrc"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="itFrNetPrcCurr"
              >
                <div class="control" :class="classes">
                  <b-select
                    class="itFrNetPrcCurr"
                    v-model="row.itFrNetPrcCurr"
                    :value="
                      row.itFrNetPrcCurr === undefined
                        ? (row.itFrNetPrcCurr = ' ')
                        : row.itFrNetPrcCurr
                    "
                    :class="
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'itFrNetPrcCurr',
                        row.itFrNetPrcCurr
                      )
                    "
                  >
                    <option value=" "></option>
                    <option value="AED">AED</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="CHF">CHF</option>
                    <option value="CZK">CZK</option>
                    <option value="DKK">DKK</option
                    ><option value="EUR">EUR</option
                    ><option value="GBP">GBP</option>
                    <option value="HKD">HKD</option>
                    <option value="JPY">JPY</option
                    ><option value="LTL">LTL</option>
                    <option value="NOK">NOK</option>
                    <option value="PLN">PLN</option>
                    <option value="SEK">SEK</option>
                    <option value="SGD">SGD</option>
                    <option value="USD">USD</option>
                    <option value="ZAR">ZAR</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="required_if:itFrNetPrcCurr"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="itNetPrc"
              >
                <div class="control" :class="classes">
                  <b-input
                    class="itNetPrc"
                    oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if(this.value.split('.')[0].length > 14) this.value = this.value.split('.')[0].slice(0, 14) + (this.value.split('.')[1] ?  '.' + this.value.split('.')[1] : '');"
                    @change.native="row.itNetPrc = $event.target.value"
                    :value="
                      row.itNetPrc !== undefined && row.itNetPrc !== 0
                        ? addTwoZerosMode(row.itNetPrc)
                        : ''
                    "
                    :class="[
                      isApiErrorField(
                        row.psfsEuNewItemPiErrTbs,
                        'itNetPrc',
                        row.itNetPrc
                      ),
                      checkIfFisherNetPriceFieldsHaveValue(row, 'itNetPrc')
                    ]"
                  ></b-input>
                </div>
              </ValidationProvider>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PriceInfoTab",
  data() {
    return {
      action: [],
      isLoading: false,
      paginationParams: [],
      priceInfoFields: {
        columns: [
          {
            className: "lineErrors",
            field: "lineErrors",
            label: "Line Errors",
            title: "Line Errors"
          },
          {
            className: "suppItemNbr",
            field: "suppItemNbr",
            label: "Supplier Item No.",
            title: "Supplier Item No.\nMax length is 25."
          },
          {
            className: "englishPrdctNoun",
            field: "englishPrdctNoun",
            label: "English Product Description",
            title: "Product Description"
          },
          {
            className: "itemStatus",
            field: "itemStatus",
            label: "Item Status",
            title: "Item Status"
          },
          {
            className: "unitPrice",
            field: "unitPrice",
            label: "Main or Alternate Unit",
            title: "Select Main or alternate unit"
          },
          {
            className: "ukRecListPrcCur",
            field: "ukRecListPrcCur",
            label: "UK Recommended List price currency",
            title: "UK Supplier standard list price currency"
          },
          {
            className: "ukRecListPrc",
            field: "ukRecListPrc",
            label: "UK Recommended List price",
            title: "UK Supplier standard list price for the item"
          },
          {
            className: "ukDscntFrmList",
            field: "ukDscntFrmList",
            label: "UK Discount from list %",
            title: "UK Discount if set % as numeric value"
          },
          {
            className: "ukFrNetPrcCurr",
            field: "ukFrNetPrcCurr",
            label: "UK Fisher Net Purchase price currency",
            title: "UK Supplier purchase price currency"
          },
          {
            className: "ukFrNetPrc",
            field: "ukFrNetPrc",
            label: "UK Fisher Net Purchase price",
            title: "UK The price Fisher pay the supplier in currency."
          },
          {
            className: "frRecListPrcCurr",
            field: "frRecListPrcCurr",
            label: "FR Recommended List price currency",
            title: "FR Supplier standard list price currency"
          },
          {
            className: "frRecListPrc",
            field: "frRecListPrc",
            label: "FR Recommended List price",
            title: "FR Supplier standard list price for the item"
          },
          {
            className: "frDscntFrmList",
            field: "frDscntFrmList",
            label: "FR Discount from list %",
            title: "FR Discount if set % as numeric value"
          },
          {
            className: "frNetPrcCurr",
            field: "frNetPrcCurr",
            label: "FR Fisher Net Purchase price currency",
            title: "FR Supplier purchase price currency"
          },
          {
            className: "frNetPrc",
            field: "frNetPrc",
            label: "FR Fisher Net Purchase price",
            title: "FR The price Fisher pay the supplier in currency."
          },
          {
            className: "deRecListPrcCur",
            field: "deRecListPrcCur",
            label: "DE Recommended List price currency",
            title: "DE Supplier standard list price currency"
          },
          {
            className: "deRecListPrc",
            field: "deRecListPrc",
            label: "DE Recommended List price",
            title: "DE Supplier standard list price for the item"
          },
          {
            className: "deDscntFrmList",
            field: "deDscntFrmList",
            label: "DE Discount from list %",
            title: "DE Discount if set % as numeric value"
          },
          {
            className: "deFrNetPrcCurr",
            field: "deFrNetPrcCurr",
            label: "DE Fisher Net Purchase price currency",
            title: "DE Supplier purchase price currency"
          },
          {
            className: "deNetPrc",
            field: "deNetPrc",
            label: "DE Fisher Net Purchase price",
            title: "DE The price Fisher pay the supplier in currency."
          },
          {
            className: "seRecListPrcCur",
            field: "seRecListPrcCur",
            label: "SE Recommended List price currency",
            title: "SE Supplier standard list price currency"
          },
          {
            className: "seRecListPrc",
            field: "seRecListPrc",
            label: "SE Recommended List price",
            title: "SE Supplier standard list price for the item"
          },
          {
            className: "seDscntFrmList",
            field: "seDscntFrmList",
            label: "SE Discount from list %",
            title: "SE Discount if set % as numeric value"
          },
          {
            className: "seFrNetPrcCurr",
            field: "seFrNetPrcCurr",
            label: "SE Fisher Net Purchase price currency",
            title: "SE Supplier purchase price currency"
          },
          {
            className: "seNetPrc",
            field: "seNetPrc",
            label: "SE Fisher Net Purchase price",
            title: "SE The price Fisher pay the supplier in currency."
          },
          {
            className: "esRecListPrcCur",
            field: "esRecListPrcCur",
            label: "ES Recommended List price currency",
            title: "ES Supplier standard list price currency"
          },
          {
            className: "esRecListPrc",
            field: "esRecListPrc",
            label: "ES Recommended List price",
            title: "ES Supplier standard list price for the item"
          },
          {
            className: "esDscntFrmList",
            field: "esDscntFrmList",
            label: "ES Discount from list %",
            title: "ES Discount if set % as numeric value"
          },
          {
            className: "esFrNetPrcCurr",
            field: "esFrNetPrcCurr",
            label: "ES Fisher Net Purchase price currency",
            title: "ES Supplier purchase price currency"
          },
          {
            className: "esNetPrc",
            field: "esNetPrc",
            label: "ES Fisher Net Purchase price",
            title: "ES The price Fisher pay the supplier in currency."
          },
          {
            className: "atRecListPrcCur",
            field: "atRecListPrcCur",
            label: "AT Recommended List price currency",
            title: "AT Supplier standard list price currency"
          },
          {
            className: "atRecListPrc",
            field: "atRecListPrc",
            label: "AT Recommended List price",
            title: "AT Supplier standard list price for the item"
          },
          {
            className: "atDscntFrmList",
            field: "atDscntFrmList",
            label: "AT Discount from list %",
            title: "AT Discount if set % as numeric value"
          },
          {
            className: "atFrNetPrcCurr",
            field: "atFrNetPrcCurr",
            label: "AT Fisher Net Purchase price currency",
            title: "AT Supplier purchase price currency"
          },
          {
            className: "atNetPrc",
            field: "atNetPrc",
            label: "AT Fisher Net Purchase price",
            title: "AT The price Fisher pay the supplier in currency."
          },
          {
            className: "fiRecListPrcCur",
            field: "fiRecListPrcCur",
            label: "FI Recommended List price currency",
            title: "FI Supplier standard list price currency"
          },
          {
            className: "fiRecListPrc",
            field: "fiRecListPrc",
            label: "FI Recommended List price",
            title: "FI Supplier standard list price for the item"
          },
          {
            className: "fiDscntFrmList",
            field: "fiDscntFrmList",
            label: "FI Discount from list %",
            title: "FI Discount if set % as numeric value"
          },
          {
            className: "fiFrNetPrcCurr",
            field: "fiFrNetPrcCurr",
            label: "FI Fisher Net Purchase price currency",
            title: "FI Supplier purchase price currency"
          },
          {
            className: "fiNetPrc",
            field: "fiNetPrc",
            label: "FI Fisher Net Purchase price",
            title: "FI The price Fisher pay the supplier in currency."
          },
          {
            className: "noRecListPrcCur",
            field: "noRecListPrcCur",
            label: "NO Recommended List price currency",
            title: "NO Supplier standard list price currency"
          },
          {
            className: "noRecListPrc",
            field: "noRecListPrc",
            label: "NO Recommended List price",
            title: "NO Supplier standard list price for the item"
          },
          {
            className: "noDscntFrmList",
            field: "noDscntFrmList",
            label: "NO Discount from list %",
            title: "NO Discount if set % as numeric value"
          },
          {
            className: "noFrNetPrcCurr",
            field: "noFrNetPrcCurr",
            label: "NO Fisher Net Purchase price currency",
            title: "NO Supplier purchase price currency"
          },
          {
            className: "noNetPrc",
            field: "noNetPrc",
            label: "NO Fisher Net Purchase price",
            title: "NO The price Fisher pay the supplier in currency."
          },
          {
            className: "dkRecListPrcCur",
            field: "dkRecListPrcCur",
            label: "DK Recommended List price currency",
            title: "DK Supplier standard list price currency"
          },
          {
            className: "dkRecListPrc",
            field: "dkRecListPrc",
            label: "DK Recommended List price",
            title: "DK Supplier standard list price for the item"
          },
          {
            className: "dkDscntFrmList",
            field: "dkDscntFrmList",
            label: "DK Discount from list %",
            title: "DK Discount if set % as numeric value"
          },
          {
            className: "dkFrNetPrcCurr",
            field: "dkFrNetPrcCurr",
            label: "DK Fisher Net Purchase price currency",
            title: "DK Supplier purchase price currency"
          },
          {
            className: "dkNetPrc",
            field: "dkNetPrc",
            label: "DK Fisher Net Purchase price",
            title: "DK The price Fisher pay the supplier in currency."
          },
          {
            className: "ptRecListPrcCur",
            field: "ptRecListPrcCur",
            label: "PT Recommended List price currency",
            title: "PT Supplier standard list price currency"
          },
          {
            className: "ptRecListPrc",
            field: "ptRecListPrc",
            label: "PT Recommended List price",
            title: "PT Supplier standard list price for the item"
          },
          {
            className: "ptDscntFrmList",
            field: "ptDscntFrmList",
            label: "PT Discount from list %",
            title: "PT Discount if set % as numeric value"
          },
          {
            className: "ptFrNetPrcCurr",
            field: "ptFrNetPrcCurr",
            label: "PT Fisher Net Purchase price currency",
            title: "PT Supplier purchase price currency"
          },
          {
            className: "ptNetPrc",
            field: "ptNetPrc",
            label: "PT Fisher Net Purchase price",
            title: "PT The price Fisher pay the supplier in currency."
          },
          {
            className: "chRecListPrcCur",
            field: "chRecListPrcCur",
            label: "CH Recommended List price currency",
            title: "CH Supplier standard list price currency"
          },
          {
            className: "chRecListPrc",
            field: "chRecListPrc",
            label: "CH Recommended List price",
            title: "CH Supplier standard list price for the item"
          },
          {
            className: "chDscntFrmList",
            field: "chDscntFrmList",
            label: "CH Discount from list %",
            title: "CH Discount if set % as numeric value"
          },
          {
            className: "chFrNetPrcCurr",
            field: "chFrNetPrcCurr",
            label: "CH Fisher Net Purchase price currency",
            title: "CH Supplier purchase price currency"
          },
          {
            className: "chNetPrc",
            field: "chNetPrc",
            label: "CH Fisher Net Purchase price",
            title: "CH The price Fisher pay the supplier in currency."
          },
          {
            className: "nlRecListPrcCur",
            field: "nlRecListPrcCur",
            label: "NL Recommended List price currency",
            title: "NL Supplier standard list price currency"
          },
          {
            className: "nlRecListPrc",
            field: "nlRecListPrc",
            label: "NL Recommended List price",
            title: "NL Supplier standard list price for the item"
          },
          {
            className: "nlDscntFrmList",
            field: "nlDscntFrmList",
            label: "NL Discount from list %",
            title: "NL Discount if set % as numeric value"
          },
          {
            className: "nlFrNetPrcCurr",
            field: "nlFrNetPrcCurr",
            label: "NL Fisher Net Purchase price currency",
            title: "NL Supplier purchase price currency"
          },
          {
            className: "nlNetPrc",
            field: "nlNetPrc",
            label: "NL Fisher Net Purchase price",
            title: "NL The price Fisher pay the supplier in currency."
          },
          {
            className: "beRecListPrcCur",
            field: "beRecListPrcCur",
            label: "BE Recommended List price currency",
            title: "BE Supplier standard list price currency"
          },
          {
            className: "beRecListPrc",
            field: "beRecListPrc",
            label: "BE Recommended List price",
            title: "BE Supplier standard list price for the item"
          },
          {
            className: "beDscntFrmList",
            field: "beDscntFrmList",
            label: "BE Discount from list %",
            title: "BE Discount if set % as numeric value"
          },
          {
            className: "beFrNetPrcCurr",
            field: "beFrNetPrcCurr",
            label: "BE Fisher Net Purchase price currency",
            title: "BE Supplier purchase price currency"
          },
          {
            className: "beNetPrc",
            field: "beNetPrc",
            label: "BE Fisher Net Purchase price",
            title: "BE The price Fisher pay the supplier in currency."
          },
          {
            className: "ieRecListPrcCur",
            field: "ieRecListPrcCur",
            label: "IE Recommended List price currency",
            title: "IE Supplier standard list price currency"
          },
          {
            className: "ieRecListPrc",
            field: "ieRecListPrc",
            label: "IE Recommended List price",
            title: "IE Supplier standard list price for the item"
          },
          {
            className: "ieDscntFrmList",
            field: "ieDscntFrmList",
            label: "IE Discount from list %",
            title: "IE Discount if set % as numeric value"
          },
          {
            className: "ieFrNetPrcCurr",
            field: "ieFrNetPrcCurr",
            label: "IE Fisher Net Purchase price currency",
            title: "IE Supplier purchase price currency"
          },
          {
            className: "ieNetPrc",
            field: "ieNetPrc",
            label: "IE Fisher Net Purchase price",
            title: "IE The price Fisher pay the supplier in currency."
          },
          {
            className: "itRecListPrcCur",
            field: "itRecListPrcCur",
            label: "IT Recommended List price currency",
            title: "IT Supplier standard list price currency"
          },
          {
            className: "itRecListPrc",
            field: "itRecListPrc",
            label: "IT Recommended List price",
            title: "IT Supplier standard list price for the item"
          },
          {
            className: "itDscntFrmList",
            field: "itDscntFrmList",
            label: "IT Discount from list %",
            title: "IT Discount if set % as numeric value"
          },
          {
            className: "itFrNetPrcCurr",
            field: "itFrNetPrcCurr",
            label: "IT Fisher Net Purchase price currency",
            title: "IT Supplier purchase price currency"
          },
          {
            className: "itNetPrc",
            field: "itNetPrc",
            label: "IT Fisher Net Purchase price",
            title: "IT The price Fisher pay the supplier in currency."
          }
        ]
      },
      rows: [],
      rowIds: []
    };
  },
  props: ["piTabSubmissionID", "loadPITabData"],
  watch: {
    loadPITabData(value) {
      if (value.loadDetails) {
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        this.loadTabItemDetails();
      }
    }
  },
  mounted() {},
  methods: {
    addTwoZerosMode(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addPercentMode(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    changeOnRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(sessionStorage.getItem("piEuRows"));
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("piEuRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsEuNewItemPiErrTbs" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              this.updatePiItem(rowData, index);
              break;
            }
          }
        }
      }
    },
    checkIfFisherNetPriceFieldsHaveValue(rowData, fieldName) {
      var fisherNtPrcFields = {};
      fisherNtPrcFields = {
        ukFrNetPrc: rowData.ukFrNetPrc,
        frNetPrc: rowData.frNetPrc,
        deNetPrc: rowData.deNetPrc,
        seNetPrc: rowData.seNetPrc,
        esNetPrc: rowData.esNetPrc,
        atNetPrc: rowData.atNetPrc,
        fiNetPrc: rowData.fiNetPrc,
        noNetPrc: rowData.noNetPrc,
        dkNetPrc: rowData.dkNetPrc,
        ptNetPrc: rowData.ptNetPrc,
        chNetPrc: rowData.chNetPrc,
        nlNetPrc: rowData.nlNetPrc,
        beNetPrc: rowData.beNetPrc,
        ieNetPrc: rowData.ieNetPrc,
        itNetPrc: rowData.itNetPrc
      };
      if (Object.keys(fisherNtPrcFields).every(k => !fisherNtPrcFields[k])) {
        return "invalid";
      } else {
        ("");
      }
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (errorFieldNames && errorFieldNames.length > 0) {
        for (var i = 0; i < errorFieldNames.length; i++) {
          if (
            errorFieldNames[i].columnName
              .split(" ")[0]
              .replace(/_/g, "")
              .toLowerCase() === className.toLowerCase()
          ) {
            return "api-error";
          }
        }
      }
    },
    onRowClick(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    loadTabItemDetails() {
      var scope = this;
      scope.isLoading = true;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        this.actions.fErrors ||
        this.actions.fSuppItemNbr ||
        this.actions.fProductNoun ||
        this.actions.fReworkItem
      ) {
        requestPayload.actions.push("Filter");
        requestPayload.filterMap = {};
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fSuppItemNbr) {
          requestPayload.filterMap.suppItemNbr = this.actions.fSuppItemNbr;
        }
        if (this.actions.fProductNoun) {
          requestPayload.filterMap.englishPrdctNoun = this.actions.fProductNoun;
        }
        if (this.actions.fReworkItem) {
          requestPayload.filterMap.itemStatus = "K";
        }
      }
      if (this.actions.sortSuppItemNbr) {
        requestPayload.actions.push("Sort");
        requestPayload.sortMap = {};
        requestPayload.sortMap.suppItemNbr = this.actions.sortSuppItemNbr;
      }
      if (this.actions.srFieldName && this.actions.srFieldValue) {
        requestPayload.actions.push("Search");
        requestPayload.searchMap = {};
        requestPayload.searchMap[
          this.actions.srFieldName
        ] = this.actions.srFieldValue;
      }

      scope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/getPriceInfo?nbrNewItemCrKey=${scope.piTabSubmissionID}&pageIndex=${scope.paginationParams.pageIndex}&noOfRecords=${scope.paginationParams.numberOfItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var piPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          scope.$emit("piPaginationParams", piPaginationParams);
          scope.$emit("piCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.piTabErrorCount
          });

          //check supplier validate value
          if (sessionStorage.getItem("se_ni_user_eu")) {
            if (response.data.validateForm === "Y") {
              scope.$emit("disableSupplierValidateFromTab", true);
            } else {
              scope.$emit("enableSupplierValidateFromTab", true);
            }
          }

          scope.isLoading = false;
          scope.rows = [];
          scope.rowIds = [];
          var mutableResponseRows = response.data.psfsEuNewItemPiTbs;
          if (requestPayload.actions.length > 0) {
            if (response.data.psfsEuNewItemPiTbs.length > 0) {
              for (
                var i = 0, lineNumber = piPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                scope.rowIds.push(mutableResponseRows[i].genlInfoId);
                mutableResponseRows[i].lineNumber = lineNumber;
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "piEuRows",
                JSON.stringify(response.data.psfsEuNewItemPiTbs)
              );
            } else {
              scope.rows = [];
              scope.rowIds = [];
            }
          } else {
            if (response.data.psfsEuNewItemPiTbs.length > 0) {
              for (
                var j = 0, lineNumberJ = piPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                scope.rowIds.push(mutableResponseRows[j].genlInfoId);
                mutableResponseRows[j].lineNumber = lineNumberJ;
              }
              scope.rows = mutableResponseRows;
              sessionStorage.setItem(
                "piEuRows",
                JSON.stringify(response.data.psfsEuNewItemPiTbs)
              );
            } else {
              scope.rows = [];
              scope.rowIds = [];
              sessionStorage.removeItem("rows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${scope.piTabSubmissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    },
    updatePiItem(requestPayload, index) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      if (sessionStorage.getItem("se_ni_user_eu")) {
        requestPayload.createdBy = JSON.parse(
          sessionStorage.getItem("se_ni_user_eu")
        ).networkId;
      } else {
        requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
      }

      var updatedRowData = {};

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}eu/updatePriceInfo?nbrNewItemCrKey=${scope.piTabSubmissionID}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = scope.rows[index].lineNumber;
          scope.rows[index] = apiRow;
          var piEuRows = JSON.parse(sessionStorage.getItem("piEuRows"));
          piEuRows.splice(index, 1, response.data);
          sessionStorage.setItem("piEuRows", JSON.stringify(piEuRows));
          scope.$emit("piCount", {
            totalErrorCount: response.data.errorCount,
            tabErrorCount: response.data.piTabErrorCount
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${scope.piTabSubmissionID}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".ni-app-price-info-tbody")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-app-price-info-tbody")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    }
  }
};
</script>
